import React from 'react'
import { Provider } from './Context'
import { Layout } from './Layout'

export const FromProject = () => {
  return (
    <Provider>
      <Layout />
    </Provider>
  )
}
